import React, { useContext, useEffect } from "react";
import ManagementSidebar from "components/common/ManagementSidebar";
import UserContext from "context/UserContext";
import { Orders } from "../components/admin-panel/MainPanel.tsx";
import AdminOrdersContext, {
  AdminOrdersProvider,
} from "../context/AdminOrdersContext.tsx";
const OrdersSuperAdmin = () => {
  const { setSuperAdminOrders } = useContext(UserContext);
  useEffect(() => {
    setSuperAdminOrders(true);
  }, []);
  return (
    <div className="d-flex">
      {/* <ManagementSidebar></ManagementSidebar> */}
      <AdminOrdersProvider>
        <Orders />
      </AdminOrdersProvider>
    </div>
  );
};
export default OrdersSuperAdmin;
